export default __webpack_public_path__ + "static/media/2023-brestovat-acoperis.cb6e5a4b.jpg";